// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CruiseActivity\ApiCruiseActivity.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BerthReservation, BerthReservationData, BerthReservationOptions } from 'data/models/BerthReservation';

// CruiseActivityData is the class that CruiseActivity serializes to/from
export interface CruiseActivityData {
    Id : number;
	
    Reservation : BerthReservationData | null;
    ReservationId : number;
	
    Crew : number | null;
    Disembark : number | null;
    Embark : number | null;
    InTransit : number | null;
    VoyageNumber : string | null;
}

// CruiseActivityOptions is the class which may be passed to the CruiseActivity constructor to define optional initial data values
export interface CruiseActivityOptions {
    Id : number;
	
    Reservation? : BerthReservationOptions | null;
    ReservationId? : number;
	
    Crew? : number | null;
    Disembark? : number | null;
    Embark? : number | null;
    InTransit? : number | null;
    VoyageNumber? : string | null;
}

export class CruiseActivity {
    public Id : DataSignal<number>;
	
    public Reservation : DataSignal<BerthReservation | null>;
    public ReservationId : DataSignal<number>;
	
    public Crew : DataSignal<number | null>;
    public Disembark : DataSignal<number | null>;
    public Embark : DataSignal<number | null>;
    public InTransit : DataSignal<number | null>;
    public VoyageNumber : DataSignal<string | null>;

    constructor();
    constructor(data : CruiseActivityOptions);
    constructor(data: CruiseActivityOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Reservation = S.value<BerthReservation | null>(null);
        this.ReservationId = jsonableObservable(S.value<number>(data && data.ReservationId !== undefined ? data.ReservationId : 0));
	    
        this.Crew = jsonableObservable(S.value<number | null>(data && data.Crew !== undefined ? data.Crew : null));
        this.Disembark = jsonableObservable(S.value<number | null>(data && data.Disembark !== undefined ? data.Disembark : null));
        this.Embark = jsonableObservable(S.value<number | null>(data && data.Embark !== undefined ? data.Embark : null));
        this.InTransit = jsonableObservable(S.value<number | null>(data && data.InTransit !== undefined ? data.InTransit : null));
        this.VoyageNumber = jsonableObservable(S.value<string | null>(data && data.VoyageNumber !== undefined ? data.VoyageNumber : null));
    }

    static key(obj : CruiseActivity) {
        return obj.Id();
    }
    
    static dataKey(obj : CruiseActivityOptions) {
        return obj.Id;
    }

    static update(obj : CruiseActivity, data : CruiseActivityOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.ReservationId !== undefined) obj.ReservationId(data.ReservationId);
	        
            if (data.Crew !== undefined) obj.Crew(data.Crew);
            if (data.Disembark !== undefined) obj.Disembark(data.Disembark);
            if (data.Embark !== undefined) obj.Embark(data.Embark);
            if (data.InTransit !== undefined) obj.InTransit(data.InTransit);
            if (data.VoyageNumber !== undefined) obj.VoyageNumber(data.VoyageNumber);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CruiseActivity.ts